module.exports = __webpack_public_path__ + "static/icon-1-aaecdcf4c7938c7e056c4b802bcd1924.png";